import React from 'react';

interface ButtonProps {
  label: any;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'none';
  disabled?: boolean;
  loading?: boolean;
  icon?: React.ReactNode;
  className?: string;
  withDropdownArrow?: boolean; // New prop for the dropdown arrow functionality
  isOpen?: boolean;
  type?: "button" | "submit" | "reset" | undefined;
}

const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  variant = 'primary',
  disabled = false,
  loading = false,
  icon,
  className = '',
  withDropdownArrow = false, // Default is false, can be true to add dropdown arrow
  isOpen = false,
  type = "button"
}) => {
  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(event);
      isOpen = !isOpen // Call the parent onClick handler if provided
    }
  };

  return (
    <button
      type={type}
      className={`btn btn-${variant} ${className}`}
      onClick={handleButtonClick}
      disabled={disabled || loading}
    >
      {label && <span className="ml-2">{label}</span>}
      {loading ? (
         <div className="inside-loader">
         <div className="spinner"></div>
       </div>
      ) : (
        icon
      )}

      {/* Dropdown arrow */}
      {withDropdownArrow && (
        <i
          className={`fa-solid fa-chevron-down ms-2 ${isOpen ? 'rotate' : ''}`}
          style={{ transition: 'transform 0.3s ease' }}
        ></i>
      )}
    </button>
  );
};

export default Button;
